import React from "react";
import CardPrimary from "../../components/card/CardPrimary";
import Avatar from "./Avatar";

// Artists
import taylorSwift from "../../media/images/taylor-swift1.jpg";
import oneDirection from "../../media/images/one-direction1.jpg";
import selenaGomez from "../../media/images/selena-gomez1.jpg";

// Albums
import niet from "../../media/images/albums/1989.png";
import fearless from "../../media/images/albums/fearless.png";
import lover from "../../media/images/albums/lover.jpg";
import red from "../../media/images/albums/red.jpg";
import reputation from "../../media/images/albums/reputation.jpg";
import speakNow from "../../media/images/albums/speak-now.jpg";

import four from "../../media/images/albums/four.png";
import mm from "../../media/images/albums/mm.png";
import tmh from "../../media/images/albums/tmh.png";
import mitam from "../../media/images/albums/mitam.jpg";

import revival from "../../media/images/albums/revival.jpg";
import forYou from "../../media/images/albums/for-you.png";
import rare from "../../media/images/albums/rare.png";
import theScene from "../../media/images/albums/the-scene.jpg";

const Albums = () => {
  return (
    <div className="albums">
      <div className="section">
        <Avatar img={taylorSwift} alt="taylor swift" name="Taylor Swift" />

        <div className="cards">
          <CardPrimary img={niet} alt="1989" text="1989" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={fearless} alt="Fearless" text="Fearless" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={lover} alt="Lover" text="Lover" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={red} alt="Red" text="Red" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={reputation} alt="Reputation" text="Reputation" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={speakNow} alt="Speak now" text="Speak now" desc="Album" onClickPlay={() => null} />
        </div>
      </div>

      <div className="section">
        <Avatar img={oneDirection} alt="one direction" name="One Direction" onClickPlay={() => null} />

        <div className="cards">
          <CardPrimary img={four} alt="Four" text="Four" desc="Album" onClickPlay={() => null} />
          <CardPrimary
            img={mm}
            alt="Midnight memories"
            text="Midnight memories"
            desc="Album"
            onClickPlay={() => null}
          />
          <CardPrimary img={tmh} alt="Take me home" text="Take me home" desc="Album" onClickPlay={() => null} />
          <CardPrimary
            img={mitam}
            alt="Made in the A.M."
            text="Made in the A.M."
            desc="Album"
            onClickPlay={() => null}
          />
        </div>
      </div>

      <div className="section">
        <Avatar img={selenaGomez} alt="selena gomez" name="Selena Gomez" onClickPlay={() => null} />

        <div className="cards">
          <CardPrimary img={revival} alt="Revival" text="Revival" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={forYou} alt="For you" text="For you" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={rare} alt="Rare" text="Rare" desc="Album" onClickPlay={() => null} />
          <CardPrimary img={theScene} alt="The scene" text="The scene" desc="Album" onClickPlay={() => null} />
        </div>
      </div>
    </div>
  );
};

export default Albums;
